import { ApiService, GenericError } from './api-main'
import TokenService from './token-service'
import store from '../store'

const ExchangeRateService = {
    getFXRateList: async function(deliveryMethodId, bankTypeId, p2hCustomerId) {
        const requestData = {
            method: 'get',
            url: 'main/fxrate/retailbranch/' + store.state.misc.appBranchId,
            headers: {
                "P2H-CustomerId": p2hCustomerId
            },
            data: {
                deliveryMethodId : deliveryMethodId,
                bankTypeId : bankTypeId
            }
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customRequest(requestData)

            return ApiService.validateResponse(response, '1100');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
    getFxCountryList: async function() {
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get('main/country/list/'+ store.state.misc.appBranchId, {})

            return ApiService.validateResponse(response, '1009');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
    getDeliveryMethodList: async function(countryId) {
        const url = 'main/deliverymethod/country/' + countryId

        const params = {
            rbId : store.state.misc.appBranchId
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '1024');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
    getFXRateAlertList: async function() {
        const url = 'main/fxratealert/list/'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, 'WN00310');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    },
    createFXRateAlert: async function(baseCurrencyId, currencyId, rate) {
        let resCreate = {invalid:false};
        const param = {
            retailAgentId   : process.env.VUE_APP_RETAIL_AGENT_ID,
            retailBranchId  : store.state.misc.appBranchId,
            p2hCustomerId   : store.state.customer.customerId,
            baseCurrencyId  : baseCurrencyId,
            currencyId      : currencyId,
            targetRate      : rate
        }
		
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin" : '*',
                "Authorization"               : `Bearer ${TokenService.getToken()}`,
                //"P2H-CustomerId"              : ApiService.getFormData("p2hCustomerId"),
            }
        };

        const url = 'main/fxratealert/create/'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, param, axiosHeader);
            //const response = await ApiService.post(url, param)

            resCreate = response.data;
			
            return resCreate;
        } catch (e) {
            resCreate.invalid = true;

            return resCreate;
            //if (e instanceof GenericError) {
            //    throw e
            //}
        }
    },
    deleteFXRateAlert: async function(id) {
        const url = 'main/fxratealert/delete/' + id
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.put(url, {})
            return ApiService.validateResponse(response, 'WN00330');
        } catch (e) {
            console.log(e)
            if (e instanceof GenericError) {
                throw e
            }
        }
    }
}

export default ExchangeRateService